import { __assign } from "tslib";
import React from 'react';
import AsyncSelect from 'react-select/async';
import AsyncCreatable from 'react-select/async-creatable';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { BasePicker, basePickerDefaultProps } from '../Picker/BasePicker';
import { styles } from '../Picker/Picker.styles';
var AsyncSelectComponent = React.forwardRef(function (props, ref) {
    return props.isCreatable ? (React.createElement(AsyncCreatable, __assign({}, props, { ref: ref }))) : (React.createElement(AsyncSelect, __assign({}, props, { ref: ref })));
});
export var AsyncPicker = function (props) { return (React.createElement(BasePicker, __assign({}, props, { ChosenSelectComponent: AsyncSelectComponent }))); };
AsyncPicker.defaultProps = basePickerDefaultProps;
export var AsyncPickerStyled = withStyles(styles)(AsyncPicker);
export default withTheme(AsyncPickerStyled);
//# sourceMappingURL=AsyncPicker.js.map